import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import BaseAuthPage from './common/BaseAuthPage';
import MainPage from './MainPage';
import LoginOTPPage from './LoginOTPPage';
import LoginCredentialsPage from './LoginCredentialsPage';
import LoginQRPage from './LoginQRPage';
import RegistrationOTPPage from './RegistrationOTPPage';
import PhoneActivationPage from './PhoneActivationPage';
import RestorePassword from './RestorePassword';
import RestorePin from './RestorePin';

export default ({ match }) => {
  const [contextState, setContextState] = useState({
    code: '+380',
    phone: '',
    email: '',
    contractNumber: '',
    userFrag: null,
  });

  return (
    <AuthContext.Provider value={{ contextState, setContextState }}>
      <BaseAuthPage>
        <Switch>
          <Route exact path={`${match.url}/`} component={MainPage} />
          <Route exact path={`${match.url}/login/otp`} component={LoginOTPPage} />
          <Route exact path={`${match.url}/login/credentials`} component={LoginCredentialsPage} />
          <Route exact path={`${match.url}/login/qr`} component={LoginQRPage} />
          <Route exact path={`${match.url}/registration/otp`} component={RegistrationOTPPage} />
          <Route exact path={`${match.url}/phone-activation`} component={PhoneActivationPage} />
          <Route path={`${match.url}/restore/password`} component={RestorePassword} />
          <Route path={`${match.url}/restore/pin`} component={RestorePin} />
        </Switch>
      </BaseAuthPage>
    </AuthContext.Provider>
  );
};
